import { z } from 'zod'

export const systemCreateSchema = z.object({
	code: z.string().min(1).max(50),
	name: z.string().min(1).max(255),
	ownerEmployeeId: z.uuid().optional(),
	category: z.string().max(100).optional(),
})

export const systemUpdateSchema = systemCreateSchema.partial()

export type SystemCreateInput = z.infer<typeof systemCreateSchema>
export type SystemUpdateInput = z.infer<typeof systemUpdateSchema>
